export const ASSEMBLY_GROUPS_URL_SLUG = 'assembly-groups';
export const STATIONS_URL_SLUG = 'stations';
export const LINES_URL_SLUG = 'lines';
export const DIRECTORIES_URL_SLUG = 'directories';
export const TRAILERS_URL_SLUG = 'trailers';
export const TRUCK_DRIVERS_URL_SLUG = 'truck-drivers';
